// Chamado interno aberto pela conversa (sem QRA/O.S/protocolo), ligado ao ticket.
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, MenuItem, TextField, Typography,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";

import suporteApi, { mensagemErro } from "./api";
import { useListas } from "./comum";

const ChamadoInternoDialog = ({ open, onClose, ticketId, nomeContato, onCriado }) => {
  const listas = useListas();
  const [f, setF] = useState({});
  const [clientes, setClientes] = useState([]);
  const [info, setInfo] = useState("");
  const [salvando, setSalvando] = useState(false);

  useEffect(() => {
    if (open) {
      setF({ titulo: "", solicitante: String(nomeContato || "").replace(/^QRA \d+ · /, ""), conta: "", observacao: "" });
      setClientes([]);
      setInfo("");
    }
  }, [open, nomeContato]);

  const campo = (nome) => ({
    value: f[nome] ?? "", onChange: (e) => setF({ ...f, [nome]: e.target.value }),
    fullWidth: true, size: "small", variant: "outlined", margin: "dense",
  });
  const buscarConta = async () => {
    if (!f.conta) return;
    try {
      const { data } = await suporteApi.get(`/api/clientes/conta/${encodeURIComponent(f.conta)}`);
      setClientes(data);
      setF((s) => ({ ...s, cliente_id: data[0]?.id }));
      setInfo(data.length === 1 ? `${data[0].nome} · ${data[0].grupo || ""}` : "");
    } catch {
      setClientes([]);
      setInfo("Conta não cadastrada");
    }
  };
  const salvar = async () => {
    setSalvando(true);
    try {
      const { data } = await suporteApi.post(`/api/whaticket/tickets/${ticketId}/interno`, {
        titulo: f.titulo, solicitante: f.solicitante, observacao: f.observacao,
        conta: f.conta || "", cliente_id: f.conta ? f.cliente_id || null : null,
      });
      toast.success("Chamado interno aberto");
      onCriado && onCriado(data.card);
      onClose();
    } catch (err) {
      toast.error(mensagemErro(err));
    }
    setSalvando(false);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Chamado interno</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="textSecondary">
          Card só para acompanhar uma demanda desta conversa (ex.: resgate de imagens). Não pede QRA nem O.S e é
          concluído sem protocolo.
        </Typography>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Autocomplete
              freeSolo options={listas.demanda || []} value={f.titulo || ""}
              onInputChange={(e, v) => setF((s) => ({ ...s, titulo: v }))}
              renderInput={(params) => (
                <TextField {...params} label="Demanda (escolha ou digite)" required size="small" variant="outlined" margin="dense" />
              )}
            />
          </Grid>
          <Grid item xs={12}><TextField label="Cliente / solicitante" required {...campo("solicitante")} /></Grid>
          <Grid item xs={4}><TextField label="Conta (opcional)" {...campo("conta")} onBlur={buscarConta} /></Grid>
          <Grid item xs={8}>
            {clientes.length > 1 ? (
              <TextField select label="Cadastro da conta" {...campo("cliente_id")}>
                {clientes.map((c) => <MenuItem key={c.id} value={c.id}>{c.nome}</MenuItem>)}
              </TextField>
            ) : (
              <Typography variant="body2" style={{ marginTop: 18 }}>{info}</Typography>
            )}
          </Grid>
          <Grid item xs={12}>
            <TextField label="Solicitação / observação" required multiline rows={3} {...campo("observacao")} />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button color="primary" variant="contained" disabled={salvando} onClick={salvar}>Abrir chamado interno</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ChamadoInternoDialog;
